import { Modal } from '../../layouts/Modal';
import { Props } from './index';
import './style.scss';
import dayjs from 'dayjs';
import { VFC, useEffect, useRef, useState } from 'react';

const DISPLAY_YEARS = 80;

export const DatePicker: VFC<Props> = ({
  date: value,
  isDefault,
  isOpen,
  defaultDate,
  min,
  max,
  onSelect,
  onCancel,
  onChange,
}) => {
  const [date, setDate] = useState(dayjs(value));
  const [isCallbackOnChange, setIsCallbackOnChange] = useState(false);
  const minLimitedAge = dayjs().diff(dayjs(max), 'year');

  useEffect(() => {
    if (!isCallbackOnChange) {
      setIsCallbackOnChange(true);
    } else {
      onChange(date.toDate());
    }
  }, [date]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        if (isOpen) onCancel();
      }}
    >
      <div className="px-4">
        <div className="my-8 text-center">
          <p className="text-brand">{isDefault ? '未選択' : dayjs(date).format('YYYY/MM/DD')}</p>
        </div>
        <div className="my-8 grid flex-1 grid-flow-col gap-3">
          <select
            className="focus:ring-brand w-full rounded-md border bg-white px-2 py-4 text-center focus:outline-none  focus:ring-2"
            value={date.year()}
            onChange={(e) => {
              const year = Number(e.currentTarget.value);
              setDate((prev) => prev.set('year', year));
            }}
          >
            {Array.from(Array(dayjs(max).diff(dayjs(min), 'y') + 1).keys())
              .map((i) => {
                const year = max.getFullYear() - i;
                return (
                  <option value={year} key={i}>
                    {year}
                  </option>
                );
              })
              .reverse()}
          </select>
          <select
            className="focus:ring-brand w-full rounded-md border bg-white px-2 py-4 text-center focus:outline-none focus:ring-2"
            value={date.month() + 1}
            onChange={(e) => {
              const month = Number(e.currentTarget.value);
              setDate((prev) => prev.set('month', month - 1));
            }}
          >
            {Array.from(Array(12).keys()).map((i) => (
              <option value={1 + i} key={i}>
                {1 + i}
              </option>
            ))}
          </select>
          <select
            className="focus:ring-brand w-full rounded-md border bg-white px-2 py-4 text-center focus:outline-none focus:ring-2"
            value={date.date()}
            onChange={(e) => {
              const date = Number(e.currentTarget.value);
              setDate((prev) => prev.set('date', date));
            }}
          >
            {Array.from(Array(date.daysInMonth()).keys()).map((i) => (
              <option value={1 + i} key={i}>
                {1 + i}
              </option>
            ))}
          </select>
        </div>
        <div className="my-8 flex w-full justify-end">
          <div>
            <button
              className="text-brand w-24"
              onClick={() => {
                onCancel();
                setDate(dayjs(defaultDate));
                setIsCallbackOnChange(false);
              }}
            >
              リセット
            </button>
          </div>
          <div>
            <button
              className={`w-24 font-semibold ${isDefault ? 'text-[#CACACA]' : 'text-brand'}`}
              onClick={onSelect}
            >
              決定
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
